export function Logo({ size = "md", className = "" }) {
    const dot = size === "sm" ? "w-2 h-2" : "w-2.5 h-2.5";
    const text = size === "sm" ? "text-base" : "text-lg";
    return (
        <div className={`flex items-center gap-2 ${className}`} data-testid="clientspace-logo">
            <div className="relative flex items-center justify-center w-7 h-7 rounded-md bg-[#0F172A]">
                <span className={`${dot} rounded-full bg-[#C55A46]`} />
                <span className="absolute w-1 h-1 rounded-full bg-white top-1.5 right-1.5" />
            </div>
            <span className={`font-display font-semibold tracking-tight text-slate-900 ${text}`}>
                Client<span className="text-[#C55A46]">Space</span>
            </span>
        </div>
    );
}
